import * as React from 'react';
import clsx from 'clsx';
import {
  createStyles,
  makeStyles,
  useTheme,
  Theme
} from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';
import './AllInvoice.scss';
import ListSubheader from '@material-ui/core/ListSubheader';
import { MuiThemeProvider } from '@material-ui/core/styles';
import theme from '../../../../../themes/theme';
import i18n from 'src/translation/i18n';

const useStyles = makeStyles((themes: Theme) =>
  createStyles({
    formControl: {
      margin: themes.spacing(1),
      minWidth: 120,
      maxWidth: 300
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap'
    },
    chip: {
      margin: 2
    },
    noLabel: {
      marginTop: theme.spacing(3)
    }
  })
);

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.8 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};

function getStyles(name: string, personName: string[], themes: Theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? themes.typography.fontWeightRegular
        : themes.typography.fontWeightMedium
  };
}

export default function MultipleSelect(props: any) {
  const classes = useStyles();
  const themes = useTheme();
  const allInvoicesVal = [
    {
      name: i18n.t('invoices.debitInvoices'),
      value: 'NC'
    },
    {
      name: i18n.t('invoices.creditInvoices'),
      value: 'subHead'
    },
    {
      name: i18n.t('invoices.allCredits'),
      value: 'CR'
    },
    {
      name: i18n.t('invoices.returnToStock'),
      value: 'RS'
    },
    {
      name: i18n.t('invoices.warranty'),
      value: 'RW'
    }
  ];
  const [personName, setPersonName] = React.useState<string[]>([]);
  const [allInvoices, setAllInvoices] = React.useState(allInvoicesVal);
  const { isReset, filter, status } = props;

  React.useEffect(() => {
    if (isReset) {
      setPersonName([]);
    }
  }, [isReset]);
  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setPersonName(event.target.value as string[]);
    filter(event.target.value);
  };

  const getAllInvoices = (val: any) => {
    if (val.value === 'subHead') {
      return <ListSubheader>{val.name}</ListSubheader>;
    }
    return <MenuItem value={val.value}>{val.name}</MenuItem>;
  };
  return (
    <div className="Invoicefilter-container">
      <MuiThemeProvider theme={theme}>
        <FormControl className={clsx(classes.formControl, classes.noLabel)}>
          <Select
            displayEmpty={true}
            value={personName}
            onChange={handleChange}
            MenuProps={MenuProps}
            inputProps={{ 'aria-label': 'Without label' }}
            className="allinvoice-select"
          >
            <MenuItem className="invoices-dropdown" value="">
              {i18n.t('invoices.allInvoices')}
            </MenuItem>
            {allInvoices &&
              allInvoices.length > 0 &&
              allInvoices.map((val: any) => getAllInvoices(val))}
          </Select>
        </FormControl>
      </MuiThemeProvider>
    </div>
  );
}
